import {
  type DealInsightsChannelKeysApi,
  type DealInsightsDirectnessKeysApi,
  type DealInsightsMediaTypeKeysApi,
  dealInsightsChannelKeysApi,
  dealInsightsDirectnessKeysApi,
  dealInsightsMediaTypeKeysApi,
} from '@openx/types/dealInsights.ts';
import type { TFunction } from 'i18next';

export const getLabelFromDistributionKeys = (
  key: DealInsightsDirectnessKeysApi | DealInsightsChannelKeysApi | DealInsightsMediaTypeKeysApi,
  t: TFunction
) => {
  const labelsMap = {
    [dealInsightsDirectnessKeysApi.TRUE]: t('Direct'),
    [dealInsightsDirectnessKeysApi.FALSE]: t('Indirect'),
    [dealInsightsChannelKeysApi.SITE]: t('Web'),
    [dealInsightsChannelKeysApi.APP]: t('App'),
    [dealInsightsMediaTypeKeysApi.CTV]: t('CTV'),
    [dealInsightsMediaTypeKeysApi.DISPLAY]: t('Banner'),
    [dealInsightsMediaTypeKeysApi.OLV]: t('OLV'),
  };

  return labelsMap[key];
};
